import { addDoc, collection, doc, getDoc, getFirestore, setDoc } from 'firebase/firestore';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import {getFunctions, httpsCallable} from 'firebase/functions';
export const sendMessage = async ({ chatId, photos = [], text }) => {
  try {
    const textStr = typeof text === 'string' ? text : '';

    // Завантаження фото до Firebase Storage
    let uploadedPhotos = [];
    if (photos.length > 0) {
      uploadedPhotos = await Promise.all(
        photos.map(async (photo, index) => {
          try {
            const file = photo?.file ?? photo;
            if (!file || typeof file.arrayBuffer !== 'function') {
              throw new Error('Некоректний файл зображення');
            }
            const fileName = `${Date.now()}-${Math.random()
              .toString(36)
              .substring(7)}-${photo?.fileName || `photo-${index}`}`;

            const url = await uploadPhotoToStorage(file, fileName, chatId);
            return url;
          } catch (uploadError) {
            console.error(
              `Помилка при завантаженні фото ${index + 1}:`,
              uploadError.message
            );
            throw uploadError;
          }
        })
      );
    }

    const messageData = {
      text: textStr,
      sender: 'manager',
      readed: false,
      photos: uploadedPhotos ?? [],
      timestamp: Date.now(),
    };

    const db = getFirestore();
    const messagesRef = collection(db, 'chats', chatId, 'messages');

      const chatRef = doc(getFirestore(), 'chats', chatId);
      const chatSnap = await getDoc(chatRef);
      if (chatSnap.exists()) {
        await setDoc(
          chatRef,
          {
            lastMessage: messageData,
            lastMessageTimestamp: messageData.timestamp,
          },
          {merge: true},
        );
      }
    await addDoc(messagesRef, messageData);

    const chatData = chatSnap.data();

    if (chatData?.clientUid) {
      const clientRef = doc(db, 'users', 'client', 'profiles', chatData.clientUid);
      const clientSnap = await getDoc(clientRef);

      if (clientSnap.exists()) {
        const clientData = clientSnap.data();
        const receiverToken = clientData?.fcmToken;

        if (receiverToken) {
          try {
            const sendPushNotification = httpsCallable(
              getFunctions(),
              'sendPushNotification'
            );

            const bodyText =
              textStr.trim() ||
              (uploadedPhotos.length > 0 ? 'Надіслано зображення' : ' ');

            await sendPushNotification({
              tokens: [receiverToken],
              title: 'Нове повідомлення від менеджера',
              body: bodyText,
              data: { chatId: String(chatId) },
              isChatMessage: true,
            });
          } catch (pushErr) {
            console.error(
              'Push після повідомлення не надіслано:',
              pushErr?.message || pushErr
            );
          }
        }
      }
    }
    return true;
  } catch (error) {
    console.error(
      'Помилка під час відправлення повідомлення:',
      error.message || error
    );
    return false;
  }
};

export const uploadPhotoToStorage = async (file, fileName, chatId) => {
  try {
    const storage = getStorage(); // Отримуємо посилання на Firebase Storage
    const storageRef = ref(storage, `chats/${chatId}/${fileName}`); // Створюємо посилання на папку чату

    // Завантажуємо файл у Firebase Storage
    await uploadBytes(storageRef, file);

    // Отримуємо URL завантаженого фото
    const downloadUrl = await getDownloadURL(storageRef);

    return downloadUrl; // Повертаємо URL фото
  } catch (error) {
    console.error('Помилка при завантаженні фото:', error.message);
    throw error; // Прокидуємо помилку нагору
  }
};
